module.exports = __webpack_public_path__ + "img/icon_from.ed8bf11c.png";